<nav class="navbar navbar-light">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/']"> medium </a>
    <ul class="nav navbar-nav pull-xs-right">
      <li class="nav-item">
        <a [routerLink]="['/']" class="nav-link">Home</a>
      </li>
      <ng-container *ngIf="isLoggedIn$ | async">
        <li class="nav-item">
          <a [routerLink]="['/articles/new']" class="nav-link"><i class="ion-compose"></i>&nbsp;New post</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/settings']" class="nav-link"><i class="ion-gear-a"></i>&nbsp;Settings</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/profiles', (currentUser$ | async).username]" class="nav-link"
            ><img [src]="(currentUser$ | async).image" alt="avatar" class="user-pic" *ngIf="(currentUser$ | async).image" />&nbsp;
            {{ (currentUser$ | async).username }}</a
          >
        </li>
      </ng-container>
      <ng-container *ngIf="isAnonymous$ | async">
        <li class="nav-item">
          <a [routerLink]="['/login']" class="nav-link">&nbsp;Login</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/register']" class="nav-link">&nbsp;Register</a>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
